import React from 'react';
import styled from 'styled-components';
import { useFlag } from '@unleash/proxy-client-react';
import SeloBlindagemIcon from '../../images/icons/selo-blindagem.svg';
import SeloGarantiaIcon from '../../images/icons/selo-garantia.svg';

const Container = styled.div.attrs(props => ({
  isDetailsPage: props.isDetailsPage,
  isCard: props.isCard,
  isParticipateCard: props.isParticipateCard,
  sealCount: props.sealCount,
}))`
  position: absolute;
  z-index: 10;
  display: flex;
  gap: ${props => (props.isCard ? '8px' : '10px')};

  ${props =>
    props.isDetailsPage &&
    `
    top: 1rem;
    left: 28.66%;
    transform: translateX(-50%);

    @media (max-width: 1800px) {
      left: 28.66%;
      transform: translateX(-50%);
    }

    @media (max-width: 1600px) {
      left:  28.66%;
      transform: translateX(-50%);
    }

    @media (max-width: 1400px) {
      left:  28.66%;
      transform: translateX(-50%);
    }

    @media (max-width: 1200px) {
      left:  28.66%;
      transform: translateX(-50%);
    }

    @media (max-width: 1000px) {
      left:  28.66%;
      transform: translateX(-50%);
    }

    @media (max-width: 920px) {
      left:  28.66%;
      transform: translateX(-50%);
    }

    @media (max-width: 720px) {
      right: 20px;
      left: auto;
      transform: none;
    }
  `}
  
  ${props =>
    props.isCard &&
    !props.isParticipateCard &&
    `
    position: absolute;
    top: 26px;
    right: 26px;
  `}

  ${props =>
    props.isCard &&
    props.isParticipateCard &&
    `
    position: absolute;
    top: 26px;
    left: 130px;

    @media (max-width: 1025px) {
      right: 26px;
      left: auto;
    }
  `}

  /* Ajusta posicionamento quando há apenas o selo de garantia no participate card */
  ${props =>
    props.isCard &&
    props.isParticipateCard &&
    props.sealCount === 1 &&
    `
    position: absolute;
    top: 26px;
    left: 175px;

    @media (max-width: 1025px) {
      right: 26px;
      left: auto;
    }
  `}

  /* Ajusta posicionamento quando há apenas 1 selo */
  ${props =>
    props.sealCount === 1 &&
    props.isDetailsPage &&
    `
    left: 32%;
    transform: translateX(-50%);

    @media (max-width: 1800px) {
      left: 32%;
      transform: translateX(-50%);
    }

    @media (max-width: 1600px) {
      left: 32%;
      transform: translateX(-50%);
    }

    @media (max-width: 1400px) {
      left: 31%;
      transform: translateX(-50%);
    }

    @media (max-width: 1200px) {
      left: 30%;
      transform: translateX(-50%);
    }

    @media (max-width: 1000px) {
      left: 29%;
      transform: translateX(-50%);
    }

    @media (max-width: 920px) {
      left: 44%;
      transform: translateX(-50%);
    }

    @media (max-width: 720px) {
      right: 20px;
      left: auto;
      transform: none;
    }
  `}
`;

const SealContainer = styled.div.attrs(props => ({
  isDetailsPage: props.isDetailsPage,
  isCard: props.isCard,
  isInContainer: props.isInContainer,
  isBlindagem: props.isBlindagem,
  sealCount: props.sealCount,
}))`
  position: ${props => (props.isInContainer ? 'relative' : 'absolute')};
  z-index: 10;
  width: ${props => (props.isCard ? '45px' : '60px')};
  height: ${props => (props.isCard ? '45px' : '60px')};

  ${props =>
    props.isInContainer &&
    `
    align-self: flex-end;
    margin-top: auto;
  `}
  
  ${props =>
    props.isDetailsPage &&
    !props.isInContainer &&
    props.isBlindagem &&
    `
    top: 1rem;
    left: 30vw;

    @media (max-width: 1800px) {
      left: 28vw;
    }

    @media (max-width: 1600px) {
      left: 28vw;
    }

    @media (max-width: 1400px) {
      left: 27vw;
    }

    @media (max-width: 1200px) {
      left: 26vw;
    }

    @media (max-width: 1000px) {
      left: 25vw;
    }

    @media (max-width: 920px) {
      left: 40vw;
    }

    @media (max-width: 720px) {
      right: 20px;
      left: auto;
    }
  `}
  
  ${props =>
    props.isDetailsPage &&
    props.isInContainer &&
    props.sealCount === 1 &&
    `
     top: 1rem;
    left: -1vw;

    @media (max-width: 1800px) {
      left: -1vw;
    }

    @media (max-width: 1600px) {
      left: 28vw;
    }

    @media (max-width: 1400px) {
      left: 27vw;
    }

    @media (max-width: 1200px) {
      left: 26vw;
    }

    @media (max-width: 1000px) {
      left: 25vw;
    }

    @media (max-width: 920px) {
      left: 40vw;
    }

    @media (max-width: 720px) {
      right: 20px;
      left: auto;
    }
  `}
  
  ${props =>
    props.isCard &&
    !props.isInContainer &&
    `
    top: 26px;
    right: 26px;
  `}
`;

const SealIcon = styled.img`
  width: ${props => (props.isBlindagem ? '120%' : '100%')};
  height: ${props => (props.isBlindagem ? '120%' : '100%')};
  object-fit: contain;
  margin-left: ${props => (props.isBlindagem ? '-10px' : '0px')};
`;

// Configuração dos selos disponíveis
const SEAL_CONFIGS = {
  blindagem: {
    flag: 'selo-blindagem',
    icon: SeloBlindagemIcon,
    alt: 'Elegível para Blindagem',
    checkEligibility: auction =>
      auction?.summary?.canHaveBlindagemBadge || auction?.auction?.vehicle?.canHaveBlindagemBadge,
    isBlindagem: true,
  },
  warranty: {
    flag: 'selo-garantia',
    icon: SeloGarantiaIcon,
    alt: 'Elegível para Garantia',
    checkEligibility: auction =>
      auction?.summary?.eligibleForWarranty || auction?.auction?.vehicle?.eligibleForWarranty,
    isBlindagem: false,
  },
};

const SealsContainer = ({
  auction,
  isDetailsPage = false,
  isCard = false,
  isParticipateCard = false,
}) => {
  const enabledBlindagem = useFlag('selo-blindagem');
  const enabledWarranty = useFlag('selo-garantia');

  // Filtra os selos baseado na elegibilidade do leilão E nas flags
  const activeSeals = Object.entries(SEAL_CONFIGS)
    .filter(([type, config]) => {
      const isEligible = config.checkEligibility(auction);
      const isEnabled = type === 'blindagem' ? enabledBlindagem : enabledWarranty;
      const shouldShow = isEligible && isEnabled;

      return shouldShow;
    })
    .map(([type, config]) => ({
      type,
      ...config,
    }));

  // Se não há selos ativos, não renderiza nada
  if (activeSeals.length === 0) {
    return null;
  }

  return (
    <Container
      isDetailsPage={isDetailsPage}
      isCard={isCard}
      isParticipateCard={isParticipateCard}
      sealCount={activeSeals.length}
    >
      {activeSeals.map(seal => (
        <SealContainer
          key={seal.type}
          isDetailsPage={isDetailsPage}
          isCard={isCard}
          isInContainer={true}
          isBlindagem={seal.isBlindagem}
          sealCount={activeSeals.length}
        >
          <SealIcon src={seal.icon} alt={seal.alt} isBlindagem={seal.isBlindagem} />
        </SealContainer>
      ))}
    </Container>
  );
};

export default SealsContainer;
